import React from 'react';
import styled from 'styled-components';
import './SubTitle.css';
import { ISubTitle } from '../../types/types';



const SubTitleComponent = styled.h2`

`;

const SubTitleThreeComponent = styled.h3`

`;

function SubTitle({ textColor, text, style, cName, children, type }: ISubTitle) {


  return (
    <>
      {type === "h2" &&
        <SubTitleComponent
          data-aos="fade-up"
          data-aos-once="true"
          className={`subtitle ${cName}`}
          style={{
            color: textColor,
            ...style
          }}
        >
          {children ? children : null}
          {text ? text : null}

        </SubTitleComponent>
      }

      {type === "h3" &&
        <SubTitleThreeComponent
          data-aos="fade-up"
          data-aos-once="true"
          className={`subtitle ${cName}`}
          style={{
            color: textColor,
            ...style
          }}
        >
          {children ? children : null}
          {text ? text : null}

        </SubTitleThreeComponent>
      }
    </>
  );
}

export default SubTitle;